<template>
  <div>
    <div>
      <div class="top-range__text">统计范围：{{ staticsInfo.rangeName }}</div>
      <div class="header-bottom">
        <span>
          统计结果：总人数<span class="num">{{ staticsInfo.totalNum || 0 }}</span>
          已报到<span class="num">{{ staticsInfo.clockNum || 0 }}</span>
          未报到<span class="num">{{ staticsInfo.notClockNum || 0 }}</span>
          <span class="num round">(</span>
          待报到<span class="num">{{ staticsInfo.waitClockNum || 0 }}</span>
          请假<span class="num">{{ staticsInfo.leaveNum || 0 }}</span>
          <span class="num round2">)</span>
        </span>
        <div class="top-right">
          <butn @click="refresh" btntype="primary" title="刷新"></butn>
          <butn v-permission="'enroll:exportEnrollClockStatus'" @click="exportClick" btntype="primary" title="导出" :loading="exportLoading"></butn>
        </div>
      </div>

    </div>
    <!--表格内容栏-->
    <DataTable :data="dataList" @selection-change="selectChange" @handleInfo="handleInfo" />
    <!--分页栏-->
    <div class="RCPagination">
      <!-- <butn
        style="float: left"
        btntype="primary"
        iconName="el-icon-arrow-left"
        title="返回"
        @click="goBack"
      ></butn> -->
      <RCPagination ref="pagination" :startRequest="false" v-model="dataList" :api="api" />
    </div>
  </div>
</template>
<script>
import butn from "@/components/button"
import DataTable from "./dataTable.js"
import RCPagination from "@/components/pagination/paginationManage";
import { classEnrollGroupStatics, classEnrollGroupStatsPage, exportGroupStatics } from "@/api/classOffline.js"
import { ioRead } from "@/utils/common.js";
export default {
  components: { butn, DataTable, RCPagination },
  data() {
    return {
      exportLoading: false,
      dataList: [],
      api: classEnrollGroupStatsPage,
      classId: "",
      classChildId: null,
      // 初始进俩请求的所有分组的统计结果
      totalStatsInfo: {
        rangName: "",
        totalNum: 0,
        clockNum: 0,
        notClockNum: 0,
        leaveNum: 0,
        waitClockNum: 0
      },
      // 选中数据的统计结果
      selectStatsInfo: {
        totalNum: 0,
        clockNum: 0,
        notClockNum: 0,
        leaveNum: 0,
        waitClockNum: 0
      },
      selectList: [],
    };
  },
  created() {
    this.classId = this.$route.query.id || "";
    if (this.$route.query.classChildId) {
      this.classChildId = this.$route.query.classChildId;
    }
    this.$nextTick(() => {
      this.refresh();
    });

  },
  methods: {
    getTotalStatistics() {
      classEnrollGroupStatics(this.getParams()).then((res) => {
        if (res.code == 0) {
          const data = res.data || {};
          this.totalStatsInfo = {
            ...data,
            rangeName: '全部分组'
          };
        }
      })
    },
    refresh() {
      this.getTotalStatistics();
      this.$refs.pagination.reload(this.getParams());
    },
    exportClick() {
      this.exportLoading = true;
      exportGroupStatics(this.getParams()).then((res) => {
        this.exportLoading = false;
        ioRead(res)
      }).catch(() => {
        this.exportLoading = false;
      });
    },
    handleInfo(row) {
      this.$emit('handleInfo', row);
    },
    selectChange(list) {
      this.selectList = list;

      // 初始化选中统计信息
      this.selectStatsInfo = {
        rangeName: '',
        totalNum: 0,
        clockNum: 0,
        notClockNum: 0,
        leaveNum: 0,
        waitClockNum: 0
      };

      if (list && list.length > 0) {
        // 累加统计字段
        list.forEach(item => {
          this.selectStatsInfo.totalNum += (item.totalNum || 0);
          this.selectStatsInfo.clockNum += (item.clockNum || 0);
          this.selectStatsInfo.notClockNum += (item.notClockNum || 0);
          this.selectStatsInfo.leaveNum += (item.leaveNum || 0);
          this.selectStatsInfo.waitClockNum += (item.waitClockNum || 0);
        });

        // 收集 groupName 并以逗号分割
        const groupNames = list.map(item => item.groupName).filter(name => name);
        this.selectStatsInfo.rangeName = groupNames.join('、');
      }
    },

    getParams() {
      let params = {
        classId: this.classId,
      };
      if (this.classChildId) {
        params.classChildId = this.classChildId
      }
      return params;
    },
  },

  computed: {
    staticsInfo() {
      if (this.selectList && this.selectList.length > 0) {
        return this.selectStatsInfo
      }
      return this.totalStatsInfo;
    },
  },
};
</script>
<style lang='scss' scoped>
.top-range__text {
  font-size: 14px;
  color: #333;
  line-height: 32px;
}

.header-bottom {
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  font-size: 14px;
  color: #333;
  line-height: 32px;
  .num {
    margin-left: 8px;
    margin-right: 24px;
    font-size: 24px;
    font-weight: 500;
    text-align: end;
  }

  .round {
    margin: 0;
  }
  .round2 {
    margin-left: -18px;
  }

  .top-right {
    display: flex;
  }
}
</style>